import type {ComponentProps} from 'react';

import {getFileType} from '../../../utils/attachments/utils';
import {FILE_TYPES} from '../../../utils/attachments/constants';

import {FileAttachment} from './file-attachment';
import {ImageAttachment} from './image-attachment';
import {VideoAttachment} from './video-attachment';
import {AudioAttachment} from './audio-attachment';

type Props = Omit<ComponentProps<typeof FileAttachment>, 'label'>;

export const Attachment = (props: Props) => {
    const fileType = getFileType(props.fileInfo.extension);

    switch (fileType) {
    case FILE_TYPES.IMAGE:
        return <ImageAttachment {...props} />;
    case FILE_TYPES.VIDEO:
        return <VideoAttachment {...props} />;
    case FILE_TYPES.AUDIO:
        return <AudioAttachment {...props} />;
    default:
        return <FileAttachment {...props} />;
    }
};
